import(/* webpackMode: "eager" */ "/cg-test-project/app/globals.css");
import(/* webpackMode: "eager" */ "/cg-test-project/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/cg-test-project/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/cg-test-project/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/cg-test-project/components/ui/tooltip.tsx")